import React, { useState } from 'react';
import ImagemFukyo from '../../Imagem-Fukyo/Imagem-Fukyo';
import { Configurations } from '../../../Utils/Configurations';
import axios from 'axios';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";

const VideoPlaylistItems = (props) => {
    const { item, carregaEpisodios, idPlaylist } = props;

    const [loadingExcluir, setLoadingExcluir] = useState(false);
    const [modalExcluir, setModalExcluir] = useState(false);
    const [sucessoExclusao, setSucessoExclusao] = useState(false);

    const toggleModalExcluir = () => {
        setModalExcluir(!modalExcluir);
    }

    const closeSuccessModal = () => {
        setSucessoExclusao(false);
        toggleModalExcluir();
        carregaEpisodios();
    }

    const deleteItemPlaylist = () => {
        setLoadingExcluir(true);

        const config = new Configurations();
        axios.delete(config.apiBasePath + `/playlist/video/${idPlaylist}/item/${item.id}`)
            .then((response) => {
                setSucessoExclusao(true);
                setLoadingExcluir(false);
            })
            .catch(error => {
                console.log("ERROR: ", error)
                setLoadingExcluir(false)
                toggleModalExcluir();
            })
            .finally(() => {
            });
    }

    return (
        <>
        <div className="row no-gutters card playlist-item-card mb-3">
            <div className="col-12">
                <div className="row no-gutters align-items-center px-3 py-3">
                    <div className="col-12 col-lg-10">
                        <div className="row no-gutters">
                            <div className="col-auto d-flex align-items-center">
                                <div className="badge-episodio mr-3" style={{
                                    width: '90px',
                                    backgroundColor: '#f0f0f0',
                                    borderRadius: '4px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    {/* <i className="fas fa-video" style={{ fontSize: '24px', color: '#ccc' }}></i> */}
                                    <ImagemFukyo
                                        className={`img img-fluid`}
                                        src={item.imagem}
                                        alt={`imagem-playlist`}
                                    />
                                </div>
                            </div>
                            <div className="col">
                                <p className="m-0"><strong>Título:</strong> {item.nome}</p>
                                <p className="m-0"><strong>Descrição:</strong> {item.descricao}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-2 text-right pt-3 pt-lg-0">
                        <div className="row no-gutters justify-content-end">

                            <div className="col-auto">
                                {loadingExcluir ? (
                                    <div className="spinner-border text-danger" role="status" />
                                ) :
                                    <button className='btn btn-outline-danger' onClick={toggleModalExcluir}>
                                        Remover
                                    </button>
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Modal isOpen={modalExcluir && !sucessoExclusao} toggle={toggleModalExcluir}>
            <ModalHeader toggle={toggleModalExcluir}>Confirmação de Exclusão</ModalHeader>
            <ModalBody>
                <p className="m-0">Tem certeza que deseja remover o vídeo <strong>{item.nome}</strong> da playlist?</p>
            </ModalBody>
            <ModalFooter>
                {loadingExcluir ? (
                    <div className="spinner-border text-primary" role="status" />
                ) : (
                    <>
                        <Button color="danger" onClick={deleteItemPlaylist}>Remover</Button>
                        {' '}<Button color="secondary" onClick={toggleModalExcluir}>Cancelar</Button>
                    </>
                )}
            </ModalFooter>
        </Modal>

        <Modal isOpen={sucessoExclusao} toggle={closeSuccessModal}>
            <ModalHeader toggle={closeSuccessModal}>Sucesso</ModalHeader>
            <ModalBody>
                <p className="m-0">Vídeo removido da playlist com sucesso!</p>
            </ModalBody>
            <ModalFooter>
                <Button color="success" onClick={closeSuccessModal}>Fechar</Button>
            </ModalFooter>
        </Modal>
        </>
    );
}

export default VideoPlaylistItems;
